export function ValueFormat(value, digits = 4) {
    if (value === null || value === undefined || value === '') return '';
    return parseFloat(value).toLocaleString('pl-PL', { maximumSignificantDigits: digits })
}